import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, InstagramIcon, FacebookIcon } from 'lucide-react';
import logoImg from '../../assets/logo.png';

const Footer: React.FC = () => {
  const handleCookieSettings = () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('cookie_consent');
      window.location.reload();
    }
  };

  return (
    <footer className="bg-neutral-offwhite pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center text-neutral-ink font-playfair text-xl font-bold mb-4">
              <img src={logoImg} alt="Logo Doux ce Moman" className="w-10 h-10 mr-3" />
              <span>Doux ce Moman</span>
            </Link>
            <p className="text-neutral-body font-nunito mb-6">
              Votre havre de paix dédié au bien-être des futures mamans et des nouveaux-nés.
            </p>
            {/* NAP statique pour le SEO local — ne pas supprimer ni déplacer dans un composant JS */}
            <address className="not-italic text-neutral-body font-nunito text-sm leading-relaxed mb-6">
              <span className="block font-semibold text-neutral-ink">Doux ce Moman</span>
              <span className="block">32 Rue Lyautey</span>
              <span className="block">25870 Geneuille, France</span>
              <a
                href="tel:+33628979907"
                className="block mt-1 hover:text-brand transition-colors duration-200"
              >
                06 28 97 99 07
              </a>
              <a
                href="mailto:contact@douxcemoman.fr"
                className="block hover:text-brand transition-colors duration-200"
              >
                contact@douxcemoman.fr
              </a>
            </address>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/douxcemoman/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Suivez-nous sur Instagram"
                className="w-10 h-10 rounded-full bg-brand flex items-center justify-center text-neutral-offwhite hover:bg-brand-dark transition-colors duration-300"
              >
                <InstagramIcon size={18} />
              </a>
              <a 
                href="https://www.facebook.com/douxcemoman/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Suivez-nous sur Facebook"
                className="w-10 h-10 rounded-full bg-brand flex items-center justify-center text-neutral-offwhite hover:bg-brand-dark transition-colors duration-300"
              >
                <FacebookIcon size={18} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-neutral-ink mb-4">Liens Rapides</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-neutral-body hover:text-brand transition-colors duration-300 font-nunito">
                  Nos Services
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-neutral-body hover:text-brand transition-colors duration-300 font-nunito">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/reservation" className="text-neutral-body hover:text-brand transition-colors duration-300 font-nunito">
                  Réservation
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-neutral-body hover:text-brand transition-colors duration-300 font-nunito">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-neutral-body hover:text-brand transition-colors duration-300 font-nunito">
                  Mentions Légales
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="text-neutral-body hover:text-brand transition-colors duration-300 font-nunito">
                  CGV
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-neutral-body hover:text-brand transition-colors duration-300 font-nunito">
                  Politique de Confidentialité
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-neutral-ink mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="text-accent-sage mr-2 mt-1 flex-shrink-0" size={18} />
                <span className="text-neutral-body font-nunito">32 Rue Lyautey, 25870 Geneuille</span>
              </li>
              <li className="flex items-center">
                <Phone className="text-accent-sage mr-2 flex-shrink-0" size={18} />
                <span className="text-neutral-body font-nunito whitespace-nowrap">06 28 97 99 07</span>
              </li>
              <li className="flex items-center">
                <Mail className="text-accent-sage mr-2 flex-shrink-0" size={18} />
                <span className="text-neutral-body font-nunito">contact@douxcemoman.fr</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-neutral-line mt-12 pt-8">
          <div className="flex flex-col items-center space-y-3">
            <p className="text-center text-neutral-body/80 font-nunito text-sm">
              {new Date().getFullYear()} Doux ce Moman. Tous droits réservés.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 text-xs">
              <button
                onClick={handleCookieSettings}
                className="font-semibold text-brand hover:text-brand-dark transition-colors duration-200 underline"
                type="button"
              >
                Gérer mes préférences cookies
              </button>
              <span className="text-neutral-body/50">•</span>
              <a
                href="https://www.jesuismasseur.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-body/60 hover:text-neutral-body/80 transition-colors duration-200"
              >
                https://www.jesuismasseur.fr
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;